import { render, staticRenderFns } from "./EditMilestoneDialog.vue?vue&type=template&id=74cc0784&scoped=true"
import script from "./EditMilestoneDialog.vue?vue&type=script&lang=js"
export * from "./EditMilestoneDialog.vue?vue&type=script&lang=js"
import style0 from "./EditMilestoneDialog.vue?vue&type=style&index=0&id=74cc0784&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74cc0784",
  null
  
)

export default component.exports